// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =======================================================
   Modern Admin UI for Course Cards
======================================================= */

.modern-page-container {
  padding: 1rem;
  background-color: #f9fafc;
  min-height: 100vh;
  border-radius: 0.75rem;
  margin-top: 10px;
}

/* Page Title */
.page-title {
  font-weight: 700;
  font-size: 1.8rem;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Search Input */
.search-box input {
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  transition: all 0.2s ease-in-out;
  width: 350px;
}

.search-box input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
  outline: none;
}

/* Loader */
.loader-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 320px;
}

/* Modern Course Cards */
.modern-course-card {
  border: none;
  border-radius: 1rem !important;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
}

.modern-course-card:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.2);
}

/* Text inside card */
.modern-course-card h5 {
  font-size: 1.1rem;
  letter-spacing: 0.5px;
}

.modern-course-card p {
  font-size: 0.9rem;
}

/* Fade animation for dynamic load */
.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CoursePayments/CourseCards.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oCAAoC;AACpC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* =======================================================\r\n   Modern Admin UI for Course Cards\r\n======================================================= */\r\n\r\n.modern-page-container {\r\n  padding: 1rem;\r\n  background-color: #f9fafc;\r\n  min-height: 100vh;\r\n  border-radius: 0.75rem;\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Page Title */\r\n.page-title {\r\n  font-weight: 700;\r\n  font-size: 1.8rem;\r\n  color: #1e293b;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n/* Search Input */\r\n.search-box input {\r\n  border-radius: 0.5rem;\r\n  border: 1px solid #e5e7eb;\r\n  padding: 0.6rem 1rem;\r\n  font-size: 0.95rem;\r\n  transition: all 0.2s ease-in-out;\r\n  width: 350px;\r\n}\r\n\r\n.search-box input:focus {\r\n  border-color: #6366f1;\r\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);\r\n  outline: none;\r\n}\r\n\r\n/* Loader */\r\n.loader-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 320px;\r\n}\r\n\r\n/* Modern Course Cards */\r\n.modern-course-card {\r\n  border: none;\r\n  border-radius: 1rem !important;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.modern-course-card:hover {\r\n  transform: translateY(-6px) scale(1.02);\r\n  box-shadow: 0 8px 22px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Text inside card */\r\n.modern-course-card h5 {\r\n  font-size: 1.1rem;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.modern-course-card p {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Fade animation for dynamic load */\r\n.fade-in {\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(8px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
